import Coin from '../../../../assets/svg/Coin'
import Style from '../style/appbar.module.scss'

const BigSuccess = ({ h3Text = "", textType, text }) => {
    return (
        <div className={Style.bigSuccessBox}>
            <div className={Style.infoBox2}>
                <div className={Style.infoBoxImg}>
                    {
                        textType == "image" ? <>
                            <div className={Style.infoBoxImgBox}>
                                <img src={"https://d1qj6ph0z4cul6.cloudfront.net/live/pr_f_top20_1761846755297.png"} alt="textImg" />
                            </div>
                        </>
                            : textType == "coin" ? <><Coin width={40} height={40} /> <h4>{text}</h4></> :textType == "time" ?  <><h4>{text}</h4><p>s</p></> : <h4>{text}</h4>
                    }
                </div>
                {h3Text?.length > 0 && <h3>{h3Text}</h3>}
            </div>
        </div>
    )
}

export default BigSuccess